<template>
    <v-container fluid class="page-container">
        <page-header title="Users" :subtitle="`Accounts that can sign in · ${totalLabel}`">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New user
            </v-btn>
        </page-header>

        <filter-panel :fields="filterFields" :value="listState" :loading="loading" @apply="applyFilters" />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No users match this search"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.email`]="{ item }">
                    <span class="font-weight-medium">{{ item.email }}</span>
                </template>
                <template v-slot:[`item.role`]="{ item }">
                    <v-chip x-small :color="item.dealer ? 'secondary' : 'primary'" outlined>
                        {{ item.dealer ? 'Dealer' : 'Administrator' }}
                    </v-chip>
                </template>
                <template v-slot:[`item.dealer`]="{ item }">{{ dealerName(item.dealer) }}</template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button
                            title="Delete this user?"
                            text="They will no longer be able to sign in."
                            @delete-entry="deleteItem(item, deleteUser, 'User')"
                        />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import userService from '@/services/user-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'
    import { fullName } from '@/utils/format'

    export default {
        name: 'UserRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                filterFields: [
                    { key: 'search', label: 'Search', placeholder: 'Email' }
                ],
                headers: [
                    { text: 'Email', value: 'email' },
                    { text: 'Role', value: 'role' },
                    { text: 'Dealer', value: 'dealer' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        methods: {
            fetchPage: options => userService.getUsersPage(options),
            deleteUser: id => userService.deleteUserById(id),
            dealerName(dealer) {
                return dealer && typeof dealer === 'object' ? fullName(dealer) : ''
            }
        }
    }
</script>
